import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
  dark?: boolean;
}
export function AccordionItem({
  title,
  children,
  isOpen,
  onClick,
  dark = false
}: AccordionItemProps) {
  return <div className={`border rounded-lg md:rounded-xl mb-2 md:mb-4 overflow-hidden transition-colors ${dark ? `border-brand-dark/30 ${isOpen ? 'bg-brand-light' : 'bg-brand-dark hover:bg-brand-light/50'}` : `border-brand-iceDark ${isOpen ? 'bg-brand-ice/50 shadow-md' : 'bg-brand-ice/40 hover:bg-brand-ice/60'}`}`} data-id="element-346">
      <button className="w-full px-4 py-3 md:px-6 md:py-5 text-left flex justify-between items-center focus:outline-none" onClick={onClick} data-id="element-347">
        <div className="flex-1 pr-3 md:pr-4" data-id="element-348">{title}</div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className={`flex-shrink-0 ${dark ? 'text-brand-ice/60' : 'text-brand-dark/50'}`} data-id="element-349">
          <ChevronDown className="w-5 h-5 md:w-6 md:h-6" data-id="element-350" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-351">
        {isOpen && <motion.div initial="collapsed" animate="open" exit="collapsed" variants={{
        open: {
          opacity: 1,
          height: 'auto',
          marginTop: 0
        },
        collapsed: {
          opacity: 0,
          height: 0,
          marginTop: 0
        }
      }} transition={{
        duration: 0.3,
        ease: [0.04, 0.62, 0.23, 0.98]
      }} data-id="element-352">
            <div className={`px-4 pb-4 pt-1 md:px-6 md:pb-6 md:pt-2 ${dark ? 'text-brand-ice/80' : 'text-brand-dark/70'}`} data-id="element-353">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}